import { ApiConfig } from "../../Config/ApiConfig";
import {createPostDataAction } from "./CommonAction";
import { STAFFLIST } from "../../Constants/StaffConstants";


export const StaffGetAction = (payload:any) => createPostDataAction(STAFFLIST, ApiConfig?.StaffGetList,payload,false );